import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import SubscriptionPriceList from './components/SubscriptionPriceList';
import EditSubscriptionPrice from './components/EditSubscriptionPrice';

const SubscriptionPrices = () => {
  const [listRequiresReload, setListRequiresReload] = useState(true);
  const [editSubscriptionPrice, setEditSubscriptionPrice] = useState();

  return (
    <Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">Subscription Plans Price Management</h3>
          <h3 className="page-subhead subhead">Manage workspace subscription prices</h3>
        </Col>
      </Row>
      <Row>
        <Col md={8}>
          <SubscriptionPriceList setEditSubscriptionPrice={setEditSubscriptionPrice} setListRequiresReload={setListRequiresReload} listRequiresReload={listRequiresReload} />
        </Col>
        <Col md={4}>
          <EditSubscriptionPrice subscriptionPrice={editSubscriptionPrice} setEditSubscriptionPrice={setEditSubscriptionPrice} setListRequiresReload={setListRequiresReload}/>
        </Col>
      </Row>
    </Container>
  );
};

export default SubscriptionPrices;